"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/RichMessageWrapper/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);










var _sort = require('shared/services/sort');
var _sender = require('shared/services/sender');
var _message = require('shared/enum/message');
var _consent = require('shared/services/consent');
var _contactCap = require('shared/services/contactCap');
var _Avatar = require('web/components/Avatar');
var _time = require('shared/services/time');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _Tooltip = require('web/components/Tooltip');
var _ContextMenu = require('./ContextMenu'); var _ContextMenu2 = _interopRequireDefault(_ContextMenu);
var _DeliveryStatus = require('./DeliveryStatus'); var _DeliveryStatus2 = _interopRequireDefault(_DeliveryStatus);
var _ReactionChips = require('./ReactionChips'); var _ReactionChips2 = _interopRequireDefault(_ReactionChips);
var _ReactionPicker = require('./ReactionPicker'); var _ReactionPicker2 = _interopRequireDefault(_ReactionPicker);
var _ReplyQuoteBlock = require('../ReplyQuoteBlock'); var _ReplyQuoteBlock2 = _interopRequireDefault(_ReplyQuoteBlock);

/* Another message drawn inside this one's bubble with actions of its own: the
 * text sent with a file (its caption). Mark its element with
 * MESSAGE_PART_ATTRIBUTE; while the pointer was last over it, the hover
 * buttons and menu act on it instead of the row's own message. */







 const MESSAGE_PART_ATTRIBUTE = 'data-message-part'; exports.MESSAGE_PART_ATTRIBUTE = MESSAGE_PART_ATTRIBUTE
const MESSAGE_PART_SELECTOR = `[${exports.MESSAGE_PART_ATTRIBUTE}]`

























































const RichMessageWrapper = (props) => {
  const {
    highlighted,
    messageKey,
    senderType,
    senderName,
    senderKey,
    showAvatar,
    showName,
    sentAt,
    seenBy,

    subscribers,
    currentUserKey,
    onDelete,
    onCopyMessageLink,
    onCopy,
    onDownload,
    onSaveAsTemplate,
    onTranslate,
    translating = false,
    onReply,
    onJumpToMessage,
    onRetry,
    uploadLabel,
    failureLabel,
    canRetry,
    conversationKey,
    deleted,
    deliveryStatus,
    isLastMessage,
    isEntering,
    reactions,
    onAddReaction,
    onRemoveReaction,
    replyToMessageKey,
    replyPreview,
    readOnly,
    smsDeliveryOutcomes,
    recallOnlyAwaitingConsent,
    hideActions,
    part,
  } = props
  // Refused by the contact cap: say why, and Retry can't help.
  const contactCapBlock = _contactCap.useContactCapBlock.call(void 0, deliveryStatus === _message.deliveryStatus.FAILED ? messageKey : undefined)
  const [isHover, setIsHover] = _react.useState.call(void 0, false)
  const [isContextMenuOpen, setIsContextMenuOpen] = _react.useState.call(void 0, false)
  const [isReactionPickerOpen, setIsReactionPickerOpen] = _react.useState.call(void 0, false)
  const openContextMenu = _react.useCallback.call(void 0, () => setIsContextMenuOpen(true), [])
  const closeContextMenu = _react.useCallback.call(void 0, () => setIsContextMenuOpen(false), [])
  const openReactionPicker = _react.useCallback.call(void 0, () => setIsReactionPickerOpen(true), [])
  const closeReactionPicker = _react.useCallback.call(void 0, () => setIsReactionPickerOpen(false), [])
  const handleMouseEnter = _react.useCallback.call(void 0, () => setIsHover(true), [])
  // Whether the actions are for `part`: set when the pointer moves over the
  // bubble, kept while it crosses the gap to the buttons, and frozen while a
  // menu or the picker is open so a stray move can't retarget them.
  const [isPartTargeted, setIsPartTargeted] = _react.useState.call(void 0, false)
  const bodyRef = _react.useRef(null)
  const isMenuOpen = isContextMenuOpen || isReactionPickerOpen
  const handleMouseOver = _react.useCallback.call(void 0, (event) => {
    const target = event.target 
    if (isMenuOpen || !_optionalChain([bodyRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.contains, 'call', _3 => _3(target)])) return
    setIsPartTargeted(!!target.closest(MESSAGE_PART_SELECTOR))
  }, [isMenuOpen])
  const handleMouseLeave = _react.useCallback.call(void 0, () => {
    setIsHover(false)
    setIsPartTargeted(false)
  }, [])

  _react.useEffect.call(void 0, 
    () => {
      if (!isHover) {
        closeContextMenu()
        setIsReactionPickerOpen(false)
      }
    },
    [isHover, closeContextMenu],
  )

  const isFromOtherUser = senderKey !== currentUserKey
  const isFromMe = !isFromOtherUser

  const isDelivered = deliveryStatus === _message.deliveryStatus.DELIVERED
  const hasFailed = deliveryStatus === _message.deliveryStatus.FAILED

  // The message the hover buttons and menu act on: the part (a caption) or
  // this row's own. A part is never drawn on a recalled row.
  const targetPart = isPartTargeted ? part : undefined
  const actionKey = targetPart ? targetPart.messageKey : messageKey
  const isActionDelivered = targetPart
    ? targetPart.deliveryStatus === _message.deliveryStatus.DELIVERED
    : isDelivered
  const actionOnCopy = targetPart ? targetPart.onCopy : onCopy
  const actionOnReply = targetPart ? targetPart.onReply : onReply
  const showActions = !hideActions || !!targetPart

  // Master D-108 (web only): a teammate can also delete a message whose
  // text still waits for consent, so a held text can be taken back.
  const isAwaitingConsent = !!_optionalChain([smsDeliveryOutcomes, 'optionalAccess', _4 => _4.some, 'call', _5 => _5(o => o.Status === _consent.SMS_AWAITING_CONSENT_STATUS)])
  const canDelete = !!(((isFromMe && !recallOnlyAwaitingConsent) || isAwaitingConsent)
    && !deleted && isActionDelivered && onDelete)
  const handleDelete = _react.useMemo.call(void 0, 
    () => canDelete ? () => onDelete(actionKey, conversationKey) : null,
    [canDelete, onDelete, actionKey, conversationKey],
  )
  const handleCopyMessageLink = _react.useCallback.call(void 0, 
    () => onCopyMessageLink(actionKey),
    [onCopyMessageLink, actionKey],
  )
  const handleSelectReaction = _react.useCallback.call(void 0, 
    (emoji) => {
      onAddReaction(actionKey, emoji, conversationKey)
      setIsReactionPickerOpen(false)
    },
    [onAddReaction, actionKey, conversationKey],
  )
  const handleReply = !readOnly && !deleted && isActionDelivered && actionOnReply ? actionOnReply : null

  const contextMenuContent = (
    _react2.default.createElement(_ContextMenu2.default, {
      onClose: closeContextMenu,
      onReply: handleReply,
      onCopy: actionOnCopy,
      onSaveAsTemplate: deleted ? null : _nullishCoalesce(onSaveAsTemplate, () => ( null)),
      onTranslate: _nullishCoalesce(onTranslate, () => ( null)),
      translating: translating,
      onDelete: handleDelete,
      onCopyMessageLink: handleCopyMessageLink,
      onDownload: onDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 216}}
    )
  )

  const seenBySubscribers = _react.useMemo.call(void 0, 
    () => Object.values(seenBy || {})
      .filter(s => s.IsLatestMessage)
      .sort((a, b) => _sort.sortByString.call(void 0, b.SeenTime, a.SeenTime))
      .reduce((acc, sb) => {
        const s = subscribers[sb.SubscriberKey]
        if (!s) return acc
        return s.SubscriberKey !== currentUserKey && s.SubscriberKey !== senderKey
          ? acc.concat([s])
          : acc
      }, [] ),
    [seenBy, subscribers, senderKey, currentUserKey],
  )

  return (
    _react2.default.createElement('div', {
      className: _classBuilder2.default.call(void 0, 
        "rich-message", {
          "rich-message--me": isFromMe,
          "rich-message--them": isFromOtherUser,
          "rich-message--failed": hasFailed,
          "rich-message--entering": isEntering,
          // Where the row sits in a run from one sender, for the bubble corners.
          "rich-message--run-first": showName,
          "rich-message--run-last": showAvatar,
          highlighted,
        },
      ),
      id: messageKey,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      onMouseOver: part ? handleMouseOver : undefined, __self: this, __source: {fileName: _jsxFileName, lineNumber: 244}}

      , _react2.default.createElement('div', { className: "rich-message--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 262}}
        ,  isFromOtherUser && (
          _react2.default.createElement('div', { className: "rich-message--avatar-column", __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}
            ,  showAvatar && (
              _react2.default.createElement(_Avatar.MessageAvatar, {
                size: 32,
                senderKey: senderKey,
                senderType: senderType, __self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}
              )
            )
          )
        )
        ,  !isFromOtherUser && (
          _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 
            !deleted && "no-margin",
            "rich-message--massage--hidden-timestamp",
          ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}}
            ,  !showName ? _time.getDayTimeString.call(void 0, sentAt) : "" 
          )
        )
        , _react2.default.createElement('div', { className: "rich-message--message", __self: this, __source: {fileName: _jsxFileName, lineNumber: 282}}
          , showName &&
            _react2.default.createElement('div', { className: "rich-message--message--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 284}}
              , _react2.default.createElement('span', { className: "rich-message--message--name--sender", __self: this, __source: {fileName: _jsxFileName, lineNumber: 285}}, senderName)
              , _sender.isApiKeySender.call(void 0, senderType) && (
                _react2.default.createElement('span', { className: "rich-message--message--name--api-marker", __self: this, __source: {fileName: _jsxFileName, lineNumber: 287}}
                  , _sender.API_KEY_SENDER_MARKER
                )
              )
              , _react2.default.createElement('span', {
                className: "rich-message--message--name--timestamp",
                title: _time.formatLongDisplayDate.call(void 0, sentAt), __self: this, __source: {fileName: _jsxFileName, lineNumber: 291}}

                , _time.getDayTimeString.call(void 0, sentAt)
              )
            )
          , _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 
            "rich-message--message-container",
            targetPart && "rich-message--message-container--part",
          ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 298}}
            , _react2.default.createElement('div', { className: "rich-message--message--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 302}}
              ,  !deleted && !readOnly && showActions && (
                _react2.default.createElement(_Tooltip.ControlledTooltip, {
                  place: isFromMe ? 'left' : 'right',
                  isOpen: isReactionPickerOpen,
                  onClose: closeReactionPicker,
                  // ControlledTooltip renders its content whether or not it is
                  // open — isOpen only hides it in CSS — so an eagerly built
                  // picker would mount emoji-mart once per message. Passing null
                  // while closed keeps that cost off the conversation entirely.
                  content: isReactionPickerOpen ? (
                    _react2.default.createElement(_ReactionPicker2.default, { onSelect: handleSelectReaction, __self: this, __source: {fileName: _jsxFileName, lineNumber: 313}} )
                  ) : null, __self: this, __source: {fileName: _jsxFileName, lineNumber: 304}}

                  , _react2.default.createElement('button', {
                    type: "button",
                    className: _classBuilder2.default.call(void 0, 
                      "rich-message--message--add-reaction",
                      !isHover && "hidden",
                    ),
                    onClick: openReactionPicker,
                    'aria-label': "Add reaction" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 316}}

                    , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 325}}, "add_reaction")
                  )
                )
              )
              ,  !deleted && showActions && (
                _react2.default.createElement('div', {
                  className: _classBuilder2.default.call(void 0, 
                    "rich-message--message--menu",
                    !isHover && "hidden",
                  ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 330}}

                  , _react2.default.createElement(_Tooltip.ControlledTooltip, {
                    place: isFromMe ? 'left' : 'right',
                    isOpen: isContextMenuOpen,
                    onClose: closeContextMenu,
                    content: contextMenuContent,
                    className: "inbox-participants--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 336}}

                    , _react2.default.createElement('button', {
                      type: "button",
                      className: "rich-message--message--menu-trigger",
                      'aria-label': "Message actions" ,
                      onClick: openContextMenu, __self: this, __source: {fileName: _jsxFileName, lineNumber: 343}}

                      , _react2.default.createElement('img', {
                        className: "rich-message--message--menu-icon",
                        src: "/assets/icons/header/ellipsis-dark.svg",
                        alt: "", __self: this, __source: {fileName: _jsxFileName, lineNumber: 349}}
                      )
                    )
                  )
                )
              )
            )
            , _react2.default.createElement('div', { className: "rich-message--message-body", ref: bodyRef, __self: this, __source: {fileName: _jsxFileName, lineNumber: 359}}
              ,  replyToMessageKey && onJumpToMessage && (
                _react2.default.createElement(_ReplyQuoteBlock2.default, {
                  conversationKey: conversationKey,
                  replyToMessageKey: replyToMessageKey,
                  replyPreview: replyPreview,
                  onJumpToMessage: onJumpToMessage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 361}}
                )
              )
              ,  props.children 
              , _react2.default.createElement(_ReactionChips2.default, {
                reactions: reactions,
                currentUserKey: currentUserKey,
                messageKey: messageKey,
                conversationKey: conversationKey,
                deleted: deleted,
                subscribers: subscribers,
                onAddReaction: onAddReaction,
                onRemoveReaction: onRemoveReaction,
                readOnly: readOnly, __self: this, __source: {fileName: _jsxFileName, lineNumber: 369}}
              )
            )
          )
        )
        ,  isFromOtherUser && (
          _react2.default.createElement('div', { className: "rich-message--massage--hidden-timestamp", __self: this, __source: {fileName: _jsxFileName, lineNumber: 384}}
            ,  !showName ? _time.getDayTimeString.call(void 0, sentAt) : ""
          )
        )
      )
      , _react2.default.createElement(_DeliveryStatus2.default, {
        status: deliveryStatus,
        seenBySubscribers: seenBySubscribers,
        shouldShowDeliveredIndicator: isLastMessage && isFromMe,
        isLastMessage: isLastMessage,
        onRetry: onRetry,
        uploadLabel: uploadLabel,
        failureLabel: contactCapBlock ? _contactCap.contactCapBlockedLabel.call(void 0, contactCapBlock) : failureLabel,
        canRetry: contactCapBlock ? false : canRetry,
        supportUrl: contactCapBlock ? _contactCap.BLOOMTEXT_SUPPORT_URL : undefined,
        smsDeliveryOutcomes: smsDeliveryOutcomes, __self: this, __source: {fileName: _jsxFileName, lineNumber: 389}}
      )
    )
  )
}

exports. default = RichMessageWrapper
